import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Empty } from 'antd';
import ChartCard from './ChartCard';
import { apiClient, API_ENDPOINTS } from '../../utils/api';
import styled from 'styled-components';

const COLORS = {
  textPrimary: '#E2E8F0',
  textSecondary: '#94A3B8',
  accent: '#22D3EE',
};

const ChartContainer = styled.div`
  width: 100%;
  height: 350px;
`;

interface CurrencyDistribution {
  currency: string;
  count: number;
  totalAmount: number;
}

const CurrencyDistributionChart: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<CurrencyDistribution[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get(API_ENDPOINTS.MERCHANT_GET_CURRENCY_DISTRIBUTION_IN_SWEEPS);
      if (response.data?.status === 'success' && response.data?.data) {
        setData(response.data.data);
      }
    } catch (error: any) {
      console.error('Error fetching currency distribution:', error);
    } finally {
      setLoading(false);
    }
  };

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div style={{
          background: '#161B22',
          border: '1px solid #1f2a37',
          borderRadius: '8px',
          padding: '12px',
          color: COLORS.textPrimary,
        }}>
          <p style={{ margin: 0, marginBottom: '4px', fontWeight: 600 }}>
            {data.currency}
          </p>
          <p style={{ margin: 0, color: COLORS.textSecondary }}>
            Sweeps: {data.count}
          </p>
          <p style={{ margin: 0, color: COLORS.textSecondary }}>
            Total Amount: {data.totalAmount.toFixed(4)}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <ChartCard title="Currency Distribution in Sweeps" loading={loading}>
      {!loading && data.length === 0 ? (
        <Empty description="No currency distribution data available" />
      ) : (
        <ChartContainer>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#1f2a37" />
              <XAxis
                dataKey="currency"
                stroke={COLORS.textSecondary}
                style={{ fontSize: '12px' }}
              />
              <YAxis stroke={COLORS.textSecondary} style={{ fontSize: '12px' }} />
              <Tooltip content={<CustomTooltip />} />
              <Bar dataKey="count" fill={COLORS.accent} name="Sweep Count" />
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      )}
    </ChartCard>
  );
};

export default CurrencyDistributionChart;

